import initFilterAccordion from './filter-accordion';
import getFilterableContent from './fetch';
import { setParams, getParams } from './params.js';
import setInputs from './inputs';

/**
 * Initiate filterable content blocks logic.
 */
const initFilterableContent = () => {
	initFilterAccordion();

	// Get all filterable content blocks.
	const filterableContentBlock = document.querySelectorAll('.em-filterable-content');

	// Loop through each block and apply logic only to that block.
	filterableContentBlock.forEach((block) => {
		const contentContainer = block.querySelector('.em-filterable-content__listings');
		const filterContainer = block.querySelector('.em-filterable-content__filter-container');
		const inputs = block.querySelectorAll('input');
		const search = block.querySelectorAll('.search');

		// Process filters and search values.
		const getFilteredContent = () => {
			filterContainer.setAttribute('data-page', 1);
			setParams(block);
			getFilterableContent(contentContainer, getParams(block));
		};

		// Loop through inputs and set event handlers.
		inputs.forEach((input) => {
			if (input.type === 'checkbox') {
				input.onchange = () => {
					getFilteredContent();
				};
			} else {
				input.onkeyup = (e) => {
					if (e.code === 'Enter') {
						getFilteredContent();
					}
				};
			}
		});

		search.forEach((button) => {
			button.onclick = () => {
				getFilteredContent();
			};
		});

		// Set exisitng values from query string.
		setInputs(block);

		// Get parameters.
		const params = getParams(block);

		// If pagination type is load more reset page to 1 on refresh.
		if (params.pagination === 'load_more') {
			filterContainer.setAttribute('data-page', 1);
		}

		// Get initial list of posts and output.
		getFilterableContent(contentContainer, params);

		window.addEventListener('popstate', () => {
			// Set exisitng values from query string.
			setInputs(block);
			getFilterableContent(contentContainer, getParams(block));
		}, false);
	});
};

document.addEventListener('DOMContentLoaded', initFilterableContent);
